import { render, staticRenderFns } from "./GenvitePersons.vue?vue&type=template&id=2df649ec&"
import script from "./GenvitePersons.vue?vue&type=script&lang=js&"
export * from "./GenvitePersons.vue?vue&type=script&lang=js&"
import style0 from "./GenvitePersons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports